export const GET_CART_ITEM_GROUPS = /* GraphQL */ `
  query GetCartItemGroups {
    me {
      id
      isIncomplete
      cart {
        id
        itemsGroups {
          participant {
            ... on Account {
              id
            }
            ... on Child {
              id
            }
          }
        }
      }
    }
  }
`;
